'use es6';

import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { List } from 'foundations-components/transitional/components/List';
import withModalProps from 'ContentEditorUI/containers/withModalProps';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import { userInfoSync } from 'hub-http/userInfo';
import { getSaveError } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { H2 } from 'foundations-components/transitional/components/H2';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { reloadWithoutWarning } from 'ContentEditorUI/redux/actions/appActions';
import { View } from 'foundations-components/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  error: getSaveError(state)
});
const mapDispatchToProps = {
  reload: reloadWithoutWarning
};

/**
 * @param {Object} props
 * @param {Object} props.error (required)
 * @param {Function} props.onClose (required)
 * @param {Function} props.reload (required)
 * @param {string} props.contentNounKey (required)
 */
class LockedModal extends Component {
  constructor(...args) {
    super(...args);
    this.handleReload = () => {
      this.props.reload();
    };
  }
  getErrorUserName() {
    const {
      error
    } = this.props;
    return error.updatedUserName;
  }
  isSameUser() {
    return userInfoSync().user.email === this.getErrorUserName();
  }
  render() {
    const {
      onClose,
      contentNounKey
    } = this.props;
    const isSameUser = this.isSameUser();
    const errorUser = this.getErrorUserName();
    const lockedTypeKey = isSameUser ? 'sameUser' : 'otherUser';
    return /*#__PURE__*/_jsxs(Modal, {
      "data-test-id": "locked-modal",
      children: [/*#__PURE__*/_jsx(DialogHeader, {
        children: /*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.heading'
          })
        })
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `lockedModal.${lockedTypeKey}`,
            options: {
              user: errorUser,
              contentType: I18n.text(contentNounKey)
            }
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.instructions1'
          })
        }), /*#__PURE__*/_jsxs(List, {
          styled: true,
          wrapChildren: true,
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions2'
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions3'
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions4'
            })
          }), /*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.instructions5'
            })
          })]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        align: 'center',
        children: [/*#__PURE__*/_jsx(View, {
          inlineSize: "100%",
          children: /*#__PURE__*/_jsx(Button, {
            use: "primary",
            onClick: onClose,
            marginBlockEnd: "400",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.primaryButtonText'
            })
          })
        }), /*#__PURE__*/_jsxs(Paragraph, {
          marginInlineStart: "0",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: 'lockedModal.footer'
          }), /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: this.handleReload,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: 'lockedModal.secondaryButtonText'
            })
          })]
        })]
      })]
    });
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(withModalProps(LockedModal, MODAL_TYPES.LOCKED_MODAL));